import he from 'he';
import { parseMusicians } from '@shared/libs';
import type { Locale } from '@shared/libs';
import { NotesCardQueryData } from '@shared/types';
import { P1 } from '@shared/ui';
import styles from './description.module.css';

type TProps = {
  locale: Locale;
  data: NotesCardQueryData['data'];
};

const CONF_TEMPLATE: Record<string, keyof Locale> = {
  'piano-easy': 'NOTE_TAB_DSCR_PIANO_EASY_TMPL',
  'piano-solo': 'NOTE_TAB_DSCR_PIANO_SOLO_TMPL',
  'piano-vocal': 'NOTE_TAB_DSCR_PIANO_VOKAL_TMPL',
  'guitar-tab-easy': 'NOTE_TAB_DSCR_GUITAR_TAB_EASY_TMPL',
  'guitar-tab': 'NOTE_TAB_DSCR_GUITAR_TAB_TMPL',
  'guitar-Chords-Tabs': 'NOTE_TAB_DSCR_GUITAR_CHORDS_TABS_TMPL',
  'guitar-accord': 'NOTE_TAB_DSCR_GUITAR_ACCORD_TMPL',
  pianino_solo_v_4_ruki: 'NOTE_TAB_DSCR_PIANO_SOLO_4_TMPL',
  'piano-vocal-easy': 'NOTE_TAB_DSCR_PIANO_VOCAL_EASY_TMPL',
  'guitar-vocal-tab': 'NOTE_TAB_DSCR_GUITAR_VOCAL_TAB_TMPL',
  ukulele: 'NOTE_TAB_DSCR_UKULELE_TMPL',
  'bayan-vocal': 'NOTE_TAB_DSCR_BAYAN_VOCAL_TMPL',
  'balalaika-vocal': 'NOTE_TAB_DSCR_BALALAIKA_VOCAL_TMPL',
  'piano-violin': 'NOTE_TAB_DSCR_PIONINO_VIOLIN_TMPL',
  flute: 'NOTE_TAB_DSCR_FLUTE_TMPL',
  'piano-easy-сhords': 'NOTE_TAB_DSCR_PIONINO_EASY_CHORDS_TMPL',
  'piano-solo-chords': 'NOTE_TAB_DSCR_PIONINO_SOLO_CHORDS_TMPL',
  'piano-vocal-сhords': 'NOTE_TAB_DSCR_PIONINO_VOCAL_CHORDS_TMPL',
  violin: 'NOTE_TAB_DSCR_VIOLIN_TMPL',
  vocal: 'NOTE_TAB_DSCR_VOCAL_TMPL',
};

function generateText(tmpl: string, data: NotesCardQueryData['data']) {
  const { title, genres, instruments, price, musicians } = data;

  let text = tmpl;
  text = text.replaceAll('%title%', he.decode(title));
  text = text.replaceAll('%genres%', genres?.map((g) => he.decode(g?.title || '')).join(', '));
  text = text.replaceAll(
    '%instruments%',
    instruments?.map((g) => he.decode(g?.title || '')).join(', ') || '',
  );
  text = text.replaceAll(
    '%musicians%',
    musicians?.map((g) => he.decode(g?.title || '')).join(', ') || '',
  );
  text = text.replaceAll('%price%', he.decode(price?.MIDI?.PRINT_VALUE || ''));

  return text;
}

export const Text = ({ locale, data }: TProps) => {
  const arrangementId = data.arrangement.id;

  const template = he.decode(
    locale[CONF_TEMPLATE[arrangementId]] || CONF_TEMPLATE[arrangementId] || '',
  );

  // нет шаблона - дефолтный текст
  if (!template) {
    const { article, genres, title, instruments, musicians, pdfpages } = data;
    return (
      <P1 className={styles.charsDesc}>
        {`${parseMusicians(musicians)} ${he.decode(title)} ${locale.NOTE_TAB_DSCR_FRAGMENT_1} ${
          instruments
            ? instruments?.map((instrument) => instrument.title).join(', ')
            : '[Instrument]'
        }${pdfpages ? ` из ${pdfpages} страниц.` : '.'} ${
          genres?.[0]
            ? `${locale.NOTE_TAB_DSCR_GENRE} ${genres?.map((g) => g.title).join(', ')}.`
            : '[Genres].'
        } ${locale.NOTE_TAB_DSCR_FRAGMENT_2} ${article}.`}
        <br />
        <br />
        {locale.NOTE_TAB_DSCR_FRAGMENT_3}
        <br />
        <br />
        {`${locale.NOTE_TAB_DSCR_FRAGMENT_4} ${parseMusicians(musicians)} ${he.decode(title)} ${
          locale.NOTE_TAB_DSCR_FRAGMENT_5
        }  ${
          instruments
            ? instruments?.map((instrument) => instrument.title).join(', ')
            : '[Instrument]'
        }`}
      </P1>
    );
  }

  return <P1 className={styles.charsDesc} html={generateText(template, data)} />;
};
